const getBlockId = uniqueId => {
  return `block-${uniqueId}`;
};

export default getBlockId;
